// AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("Data");
      const storedPermissions = localStorage.getItem("permissions");

      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
      if (storedPermissions) {
        setPermissions(JSON.parse(storedPermissions));
      }
    } catch (error) {
      console.error("Failed to restore auth state:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const login = (userData) => {
    setUser(userData);
    const perms = userData.permissions || [];
    setPermissions(perms);
    localStorage.setItem("Data", JSON.stringify(userData)); // ✅ same key
    localStorage.setItem("permissions", JSON.stringify(perms));
  };

  const logout = () => {
    setUser(null);
    setPermissions([]);
    localStorage.removeItem("Data");
    localStorage.removeItem("permissions");
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider
      value={{
        user,
        permissions,
        loading,
        isAuthenticated,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
